import React, { useState } from "react";
import "../card.css";
import useAnimateOnScroll from "../hooks/useAnimateOnScroll.js";

import screenshot1 from '../resources/Screenshot 2025-04-01 165743.png';
import screenshot2 from '../resources/Screenshot 2025-04-01 170929.png';
import screenshot3 from '../resources/Screenshot 2025-04-01 171017.png';

import screenshot4 from '../resources/Screenshot 2025-04-01 185040.png';
import screenshot5 from '../resources/Screenshot 2025-04-01 185129.png';
import screenshot6 from '../resources/Screenshot 2025-04-01 185334.png';

import screenshot7 from '../resources/Login.png';
import screenshot8 from '../resources/PoIs.png';
import screenshot9 from '../resources/Results.png';

const Projects = () => {
  useAnimateOnScroll();

  const [fullscreenImg, setFullscreenImg] = useState(null);

  const openImage = (src) => {
    setFullscreenImg(src);
  };

  const closeImage = () => {
    setFullscreenImg(null);
  };

  return (
    <div id="projects" className="container view">
      <ul id="cards">
        <li className="card" id="card0">
          <div className="card-body">
            <h1>Projects</h1>
            <div className="arrow"></div>
            <div className="arrow"></div>
          </div>
        </li>

        {/* Travel Buddy */}
        <li className="card" id="card1">
          <div className="card-body">
            <h2>Travel Buddy</h2>
            <div className="project-content">
              <div className="images travelbuddy">
                {[screenshot7, screenshot8, screenshot9].map((img, i) => (
                  <img
                    key={i}
                    className="image upright"
                    src={img}
                    alt={`screenshot Travelbuddy${i+1}`}
                    onClick={() => openImage(img)}
                  />
                ))}
              </div>
              <div className="text">
                <a href="https://hdm-stuttgart.de/stage/projekt_detail/projekt_details?projekt_ID=4733" target="_blank"   style={{ color: 'white' }}>TravelBuddy</a> hilft dir, dein perfektes Reiseziel zu finden! 
                Die App schlägt Städte vor, die zu Reisezeitraum, Klima und persönlichen Vorlieben passen, ob spontan oder geplant. 
                Entwickelt mit Java und Python im Backend, React Native für Mobile, Docker für Containerisierung sowie MongoDB und PostgreSQL für Daten. 
                Keycloak sorgt für sicheres Usermanagement.
              </div>
            </div>
          </div>
        </li>

        {/* Jukeboxd */}
        <li className="card" id="card2">
          <div className="card-body">
            <h2>Jukeboxd</h2>
            <div className="project-content">
              <div className="images">
                {[screenshot1, screenshot2, screenshot3].map((img, i) => (
                  <img
                    key={i}
                    className="image"
                    src={img}
                    alt={`screenshot Jukeboxd${i+1}`}
                    onClick={() => openImage(img)}
                  />
                ))}
              </div>
              <div className="text">
                Jukeboxd ist eine Webanwendung, die Nutzern hilft, Informationen zu Künstlern, Alben, Songs und Labels zu entdecken. 
                Registrierte Nutzer können Alben bewerten, Reviews verfassen und ihre Lieblingsinhalte speichern. 
                Das Frontend ist mit React entwickelt, während das Backend auf Spring Boot basiert. 
                Die Daten werden in einer PostgreSQL-Datenbank gespeichert, die eine effiziente Verwaltung ermöglicht.
              </div>
            </div>
          </div>
        </li>

        {/* RecipeAI */}
        <li className="card" id="card3">
          <div className="card-body">
            <h2>RecipeAI</h2>
            <div className="project-content">
              <div className="images">
                {[screenshot4, screenshot5, screenshot6].map((img, i) => (
                  <img
                    key={i}
                    className="image"
                    src={img}
                    alt={`screenshot RecipeAI${i+1}`}
                    onClick={() => openImage(img)}
                  />
                ))}
              </div>
              <div className="text">
                RecipeAI ist ein benutzerfreundliches Rezeptbuch-Programm, das es Nutzern ermöglicht, eigene Rezepte zu erstellen und individuelle Einkaufslisten zu verwalten. 
                Mit einer umfangreichen Zutaten- und Food-Datenbank sowie Funktionen zur Organisation von Mahlzeiten bietet es eine einfache und effiziente Möglichkeit 
                zur Planung und Zubereitung von Gerichten. Entwickelt mit JavaFX und Java.
              </div>
            </div>
          </div>
        </li>
      </ul>

      {/* Vollbild-Overlay */}
      {fullscreenImg && (
        <div
          className="fullscreen-overlay"
          onClick={closeImage}
        >
          <img src={fullscreenImg} alt="fullscreen" className="fullscreen-img" />
        </div>
      )}
    </div>
  );
};

export default Projects;
